module.exports = __webpack_public_path__ + "static/media/truly_free_dark.9e2db5b4.svg";